module.exports = __webpack_public_path__ + "static/media/cat-tail-wagging.b77c4981.gif";